import {
  getFormData,
  resetFormErrors,
  showFormErrors,
} from '../../utils/form';
import * as notification from '../../components/notifications';

const initPage = () => {
  const editBillingForm = $("#edit-billing-form");
  if (!editBillingForm.length) {
    return;
  }

  editBillingForm.submit(() => {
    editBilling();

    return false;
  });
};

const getEditBillingData = () => {
  const form = $("#edit-billing-form");

  return getFormData(form);
};

const editBilling = async () => {
  const form = $("#edit-billing-form");
  const data = getEditBillingData();

  $('.btn-submit', form).loading();

  try {
    let response;
    response = await axios.post("/api/account/edit-billing-information", data);

    resetFormErrors(form);
    notification.success(response.data.message);

    $('.btn-submit', form).loading(false);
  } catch (e) {
    console.log('error', e);
    $('.btn-submit', form).loading(false);
    showFormErrors(form, e.response);
  }
};

$(initPage);
